module.exports = __webpack_public_path__ + "img/Boulangerie_3.28e41d98.jpg";